module.exports = __webpack_public_path__ + "img/solution_homecare_sys_en.ee52e6e0.jpg";